import { getAllInfluencerEarnings } from '@/service/influencer/earnings'

const state = {
  earnings: {}
}

const getters = {
  earningsStore: state => state.earnings,
}

const actions = {
  async getAllInfluencerEarnings({commit}, {userId, startDate, endDate}) {
    let filterDate = ''
    if (startDate) {
      filterDate += '&start=' + new Date(startDate).getTime() / 1000
    }
    if (endDate) {
      filterDate += '&end=' + new Date(endDate).getTime() / 1000
    }
    const response = await getAllInfluencerEarnings(userId, filterDate)
    if (response.success) {
      commit('setEarnings', response)
    }
  }
}

const mutations = {
  setEarnings(state, earnings) {
    state.earnings.result = earnings.result
    state.earnings.summary = earnings.summary
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}